import { useContext } from "react";
import "./Colors.css";
import "./App.css";
import css from "./App.module.css";

import ExportRecipe from "./components/ExportRecipe";

import Import from "./components/Import";
import TabContext from "./components/store/tab-context";
import TabContainer from "./components/TabsAndSliders/TabContainer";
import Tab from "./components/TabsAndSliders/Tab";
import SlideContainer from "./components/TabsAndSliders/SlideContainer";
import Slide from "./components/TabsAndSliders/Slide";

function App() {
  const tabContext = useContext(TabContext);
  return (
    <div className="App">
      <h1 className={css.header}>Create Recipe</h1>

      <TabContainer>
        <Tab
          tabPosition={"right"}
          leftBorderRadius={true}
          value={tabContext.values.export}
        >
          EXPORT
        </Tab>
        <Tab
          tabPosition={"left"}
          rightBorderRadius={true}
          value={tabContext.values.import}
        >
          IMPORT
        </Tab>
      </TabContainer>
      <SlideContainer>
        <Slide slidePosition={"left"}>
          <ExportRecipe />
        </Slide>
        <Slide slidePosition={"right"}>
          <Import />
        </Slide>
      </SlideContainer>
    </div>
  );
}

export default App;
